function transformarURL(url: string, tipoImg?: string): string {
  const baseURL = "https://dpjye2wk9gi5z.cloudfront.net/wcsstore/ExtendedSitesCatalogAssetStore"; //url base

  // Validar si la URL empieza con "/dx/api/dam/custom" o "/hclstore/null/images/catalog/normal"
  if (url.startsWith("/dx/api/dam/custom")) {
    url = url.replace("/dx/api/dam/custom", baseURL);
  } else if (url.startsWith("/hclstore")) {
    url = url.replace("/hclstore", baseURL);
    if (url.startsWith(`${baseURL}/null`)) {
      url = url.replace(`${baseURL}/null`, baseURL);
    }
  }

  //si el parametro tipoImg esta presente, replazamos tipo de imagen por dicho parametro
  if (tipoImg) {
    url = url.replace(/(thumbnail|zoom|normal|default)/g, tipoImg);
  }

  //nos aseguramos que dicho valor no este presente mas de 2 veces, si lo esta lo remplaza
  url = url.replace(/(\/ExtendedSitesCatalogAssetStore){2,}/g, "/ExtendedSitesCatalogAssetStore");
  return url;
}

export { transformarURL };
